const options = {
  5: "bg-sky-700/5",
  10: "bg-sky-700/10",
  25: "bg-sky-700/25",
  50: "bg-sky-700/50",
  75: "bg-sky-700/75",
  90: "bg-sky-700/90",
  100: "bg-sky-700",
};

const from = {
  5: "from-sky-700/5",
  10: "from-sky-700/10",
  25: "from-sky-700/25",
  50: "from-sky-700/50",
  75: "from-sky-700/75",
  90: "from-sky-700/90",
  100: "from-sky-700",
};

export default function getBackgroundSky700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
